export const css = {
	root: '_1A68LZTH',
	title: '_2YcrZ9Fe',
	progressBar: '_1OQrjn3E',
	innerBar: '_2n2Qjxmc',
	legend: 'ki04t5fz',
	' _key': 'progress-bar/circle'
};

export default css;
